export default "__VITE_ASSET__CneOtow8__"